import {
  PgaValidationArgs,
  PgaValidator,
} from 'libs/entryValidation/pga/types';
import { ProductUsPgaInput } from '__generated__/graphql';
import { AppRecordValidateResult } from '@xbcb/ui-types';
import { PgaFlag } from 'libs/pgaHelpers';

export class PesticidesPackagingValidator
  implements PgaValidator<ProductUsPgaInput>
{
  isApplicable({ pgaFlag }: PgaValidationArgs<ProductUsPgaInput>): boolean {
    return PgaFlag.subjectToPesticides(pgaFlag);
  }

  validate(_: PgaValidationArgs<ProductUsPgaInput>): AppRecordValidateResult {
    return {
      validateFields: [
        ['packaging', 0, 'unit'],
        ['packaging', 0, 'value'],
      ],
    };
  }
}
